const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true"><path d="M15.25 18.5a.75.75 0 0 1 0-1.5h4.19l-6.19-6.19-3.12 3.12c-.48.48-1.28.48-1.76 0L1.72 7.28a.75.75 0 0 1 1.06-1.06l6.47 6.47 3.12-3.12a1.25 1.25 0 0 1 1.76 0l6.37 6.37v-4.19a.75.75 0 0 1 1.5 0v6.75z"/></svg>';
export {
  a as w
};
